<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-row>
            <b-col sm="12">
              <b-card header-class="redmfu">
                <div slot="header">
                  <strong>สถิติการบันทึกข้อมูลจำแนกวันที่บันทึก</strong>
                </div>
                <b-row>
                  <b-col lg="2">
                    </b-col>
                  <b-col lg="8">
                     <b-table striped hover :items="items" :fields="fields" >
                    </b-table>
                  </b-col>
                  <b-col lg="2">
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="3">
                  </b-col>
                  <b-col lg="6">
                    <table border="0" width=100% align=right >
                      <tr>
                          <td ><strong>เปิดระบบทั้งหมด {{ day }}/26 วัน</strong></td >
                        <td  ><font color="green"><strong>จำนวนบัณฑิตที่เข้ามาบันทึกข้อมูล {{ total.toLocaleString()}} </strong></font></td >
                        <td  ><font color="red"><strong>จำนวนผู้ที่ยัง<u>ไม่</u>ตอบแบบสอบถาม {{ total_balance.toLocaleString() }}/{{ num_student.toLocaleString()}}</strong></font></td >
                      </tr>
                    </table >

                  </b-col>
                  <b-col lg="3">
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: { YimoVueEditor },
  name: "tables",
  data() {
    return {
      // fields: ["DATETOTAL", "TOTAL"],
      fields: [
        {
          key: "DATETOTAL",
          label: "วันที่",
          formatter: "DATETOTAL"
        },
        {
          key: "TOTAL",
          label: "จำนวนผู้ที่ตอบแบบสอบถามแล้ว",
          formatter: "TOTAL"
        }
      ],
      items: [],
      total:0,
      total_balance:0,
      day:0,
      num_student:3122,
    };
  },

  methods: {
    getStatistic(year) {
      api
        .getStatisticDate(year)
        .then(res => {

          this.items = res.data.data;
          this.day=res.data.data.length;

          for (var i= 0; i < res.data.data.length ; i++){
            // console.log("res.data.data[i].TOTAL==",res.data.data[i].TOTAL);
            this.total=res.data.data[i].TOTAL+this.total;
          }
          this.total_balance=this.num_student -this.total;
          // console.log("this.total==",this.total);
        })
        .catch(err => {
          console.log("getStatistic", err.toString());
        });
    }
  },
  mounted() {},
  created() {
    this.getStatistic(2566);
    api.onSetHeader();
  }
};
</script>
<style>
</style>
